import React, { useState } from "react";
import DrawerFilter from "../../../../../components/listing/DrawerFilter";

export default function FiltroDepartamento({ initialFilters = {}, onSubmit = () => {}, onClose = () => {} }) {
  const [nombre, setNombre] = useState(initialFilters.nombre || "");
  const [codigo, setCodigo] = useState(initialFilters.codigo || "");

  const handleApply = () => {
    onSubmit({ nombre: nombre.trim(), codigo: codigo.trim() });
    onClose();
  };

  return (
    <DrawerFilter title="Filtros de Departamentos" onClose={onClose} onApply={handleApply}>
      <div className="space-y-4">
        <div>
          <label className="form-label-fil">Nombre:</label>
          <input
            type="text"
            className="input mt-1 w-full"
            value={nombre}
            onChange={e => setNombre(e.target.value)}
            placeholder="Buscar por nombre..."
          />
        </div>
        <div>
          <label className="form-label-fil">Código:</label>
          <input
            type="text"
            className="input mt-1 w-full"
            value={codigo}
            onChange={e => setCodigo(e.target.value)}
            placeholder="Buscar por código..."
          />
        </div>
      </div>
    </DrawerFilter>
  );
}